export default __webpack_public_path__ + "static/media/logout-icon.c3eb4dd7.svg";